<div class="event-card-container" #container>
    <div class="card vertical reverse event {{selected}}"
        [ngClass]="{'flipped': selected != -1 || flipped && !spoilerFree, 'disabled': disabled}"
        [style.fontSize]="container.offsetWidth * 0.070 + 'px'">
        <div class="card-back" [ngClass]="event ? event.type : ''">
            <ng-container *ngIf="!!event">
                <div class="wrapper" [ngClass]="{'spoiler': spoilerFree}">
                    <div class="content">
                        <div class="text placeholder" [ghs-label]="event.narrative"></div>
                        <div class="options">
                            <ng-container *ngFor="let option of event.options; let i = index;">
                                <div *ngIf="option.narrative" class="option" ghs-pointer-input
                                    (singleClick)="selectOption(i, false, $event)"
                                    [ngClass]="{'single': event.options.length == 1 || !option.label}">
                                    <span *ngIf="option.label" class="title" [ghs-label]="'game.events.option'"
                                        [ghs-label-args]="[option.label]"></span>
                                    <span class="choice" [ghs-label]="option.narrative"></span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="requirement party-achievement"
                        *ngIf="event.requirement && event.requirement.partyAchievement">
                        <span [ghs-label]="'game.events.requirements'"
                            [ghs-label-args]="[event.requirement.partyAchievement]"></span>
                        <span [ghs-label]="'game.events.requirements.partyAchievement'"
                            [ghs-label-args]="[event.requirement.partyAchievement]"></span>
                    </div>
                </div>
                <div class="spoiler-free" *ngIf="spoilerFree" [ngClass]="{'light': light}">
                    <a ghs-pointer-input (singleClick)="setSpoilerFree(false, $event)">{{event.cardId}}</a>
                </div>
                <div class="card-id" ghs-pointer-input (singleClick)="setSpoilerFree(true, $event)">{{event.cardId}}
                </div>
            </ng-container>
        </div>
        <div class="card-front" [ngClass]="event ? event.type : ''">
            <ng-container *ngIf="!!event">
                <div class="options" [ngClass]="{'no-label': noLabel}">
                    <div class="option {{'option-' + option.label}}"
                        *ngFor="let option of event.options; let i = index;"
                        [ngClass]="{'selected' : !option.label || selected == i || selected == -1 && flipped, 'single': event.options.length == 1, 'no-label': !option.label, 'attack': attackIndex == i}"
                        ghs-pointer-input (doubleClick)="selectOption(selected == i ? -1 : i, false, $event)">
                        <div class="outcome" *ngFor="let outcome of option.outcomes; let outcomeIndex = index;"
                            [ngClass]="{'selected': subSelections.indexOf(outcomeIndex) != -1 || selected == -1 && flipped || !option.label && outcome.attack, 'disabled' : resolvable[i] && resolvable[i][outcomeIndex] == false && subSelections.indexOf(outcomeIndex) == -1 && selected != -1, 'expand-to-bottom': outcomeIndex == option.outcomes.length -1 && (option.returnToDeck || option.removeFromDeck), 'margin': outcome.condition || outcome.narrative}"
                            ghs-pointer-input (singleClick)="selectSub(i, outcomeIndex, $event)"
                            (doubleClick)="selectSub(i, outcomeIndex, true, $event)">
                            <ghs-event-card-condition *ngIf="outcome.condition" [condition]="outcome.condition"
                                [narrative]="true" [edition]="event.edition" [eventType]="event.type" [light]="light"
                                [selected]="selected == -1 && flipped || selected == i && subSelections.indexOf(outcomeIndex) != -1"
                                [debug]="debug"></ghs-event-card-condition>
                            <span *ngIf="outcome.condition" class="condition-spacer">:</span>
                            <span *ngIf="outcome.narrative" class="text"
                                [ngClass]="{'text-white': light, 'inline': outcome.inlineEffects && outcome.effects.length}"
                                [ghs-label]="outcome.narrative"></span>

                            <div class="effects" *ngIf="outcome.effects && outcome.effects.length"
                                [ngClass]="{'inline': outcome.inlineEffects}">
                                <ghs-event-card-effect *ngFor="let effect of outcome.effects;" [effect]="effect"
                                    [edition]="event.edition" [eventType]="event.type" [light]="light"
                                    [selected]="selected == -1 && flipped || selected == i && subSelections.indexOf(outcomeIndex) != -1"
                                    [inline]="outcome.inlineEffects || false" [debug]="debug"></ghs-event-card-effect>
                            </div>

                            <ghs-event-card-attack *ngIf="outcome.attack" [attack]="outcome.attack"
                                [edition]="event.edition" [eventType]="event.type" [light]="light" [selected]="attack"
                                (onToggle)="toggleAttack($event)" [debug]="debug"></ghs-event-card-attack>

                            <div class="card-action"
                                *ngIf="outcome.returnToDeck || outcome.removeFromDeck || outcomeIndex == option.outcomes.length -1 && (option.returnToDeck || option.removeFromDeck)">
                                <img *ngIf="outcome.returnToDeck || option.returnToDeck" class="ghs-svg"
                                    src="./assets/images/eventcards/return.svg">
                                <img *ngIf="outcome.removeFromDeck || option.removeFromDeck" class="ghs-svg"
                                    src="./assets/images/eventcards/remove.svg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-id">{{event.cardId}}</div>
            </ng-container>
        </div>
    </div>
</div>